export default "__VITE_ASSET__BelIijPr__"